import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

import style from 'style';
import SmallProviderCard from 'components/SmallProviderCard';
import * as track from 'lib/track';


const Container = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  
  .header {
    
    font-size: 20px;
    font-weight: 700;
    text-align: center;
  }
  
  .sub-header {
    font-size: 18px;
    font-weight: 500;
  }
  
  .card-container {
    margin-top: 55px;
    display: flex;
    gap: 30px;
    justify-content: center;
    width: 100%;
    
    @media (max-width: ${style.sizes.large}) {
      flex-direction: column;
      align-items: center;
      row-gap: 50px;
    }
  }
  
  .service {
    font-weight: 700;
    color: ${style.colors.secondary};
  }
`;

const SponsoredProviders = ({ data, serviceName }) => {

  if (!data || !Array.isArray(data) || !data.length) return;

  return (
    <Container>
      <div className="header">
        Meet our Featured Providers
      </div>
      <div className="sub-header header">
        Trusted experts in <span className="service">{serviceName}</span>, available while you wait
      </div>
      <div className="card-container">
        {data.map((item, index) => (
          <SmallProviderCard
            key={index}
            title={item.name}
            uuid={item.uuid}
            url={item.url}
            imagePath={item.imagePath}
            rating={item.rating}
            reviewCount={item.reviewCount}
            eventTrackerName={track.SPONSORED_SERVICE_REQUEST_TRACKING_CLICK}
          />
        ))}
      </div>
    </Container>
  );
};

SponsoredProviders.propTypes = {
  data: PropTypes.array,
  serviceName: PropTypes.string,
};


export default SponsoredProviders;

